"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactUforms = require("react-uforms");

var _uiKit = require("@dbi-tools/ui-kit");

var _select = require("@dbi-tools/ui-kit/lib/select");

var _colorPaletteFilter = require("./color-palette-filter.styled");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ColorPaletteFilterUi = function ColorPaletteFilterUi(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$resetButtonText = _ref.resetButtonText,
      resetButtonText = _ref$resetButtonText === void 0 ? 'reset' : _ref$resetButtonText,
      _ref$selectEmptyText = _ref.selectEmptyText,
      placeholder = _ref$selectEmptyText === void 0 ? 'Select a color palette' : _ref$selectEmptyText,
      isInEditor = _ref.isInEditor;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeChild = _useState2[0],
      setActiveChild = _useState2[1];

  var SELECT_NAME = 'select';
  var options = (0, _react.useMemo)(function () {
    return _react.default.Children.map(children, function (_ref2, index) {
      var _ref2$props = _ref2.props,
          caption = _ref2$props.caption,
          id = _ref2$props.id;
      return {
        value: id,
        label: caption || "option ".concat(index + 1)
      };
    });
  }, [children]);

  var mobileOptions = function mobileOptions(newOptions) {
    var optionsWithPlaceholder = [{
      label: placeholder,
      name: placeholder,
      value: null,
      hidden: true
    }].concat(_toConsumableArray(newOptions));
    return optionsWithPlaceholder.map(function (_ref3) {
      var name = _ref3.label,
          value = _ref3.value,
          disabled = _ref3.disabled,
          hidden = _ref3.hidden;
      return {
        name: name,
        value: value,
        disabled: disabled,
        hidden: hidden
      };
    });
  };

  var onChange = function onChange(_ref4) {
    var value = _ref4.value;
    setActiveChild(value);
  };

  var onSelect = function onSelect(event) {
    if (!event) return;
    var value = JSON.parse(event.target.value)['v'];
    setActiveChild(value);
  };

  var onSubmit = function onSubmit(value) {
    console.log(value);
  };

  var onReset = function onReset(api) {
    var select = document.getElementById("".concat(id, "-select"));

    if (select) {
      // @ts-ignore
      select.value = '{"v":null}';
    }

    if (api) {
      api.setValue(SELECT_NAME, null);
    }

    setActiveChild(null);
  };

  return /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_reactUforms.Form, {
    onSubmit: onSubmit
  }, function (api) {
    return /*#__PURE__*/_react.default.createElement(_colorPaletteFilter.FilterWrapStyled, null, isInEditor ? /*#__PURE__*/_react.default.createElement(_reactUforms.Select, {
      multiple: false,
      options: mobileOptions(options),
      name: SELECT_NAME,
      onChange: onSelect,
      value: activeChild,
      id: "".concat(id, "-select")
    }) : /*#__PURE__*/_react.default.createElement(_select.FormSelect, {
      isMulti: false,
      onChange: onChange,
      options: options,
      placeholder: placeholder,
      value: activeChild,
      name: SELECT_NAME
    }), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      color: "gray800",
      measure: "md",
      uppercase: true,
      variant: "outlined",
      ml: 15,
      onClick: function onClick() {
        return onReset(api);
      },
      type: "button"
    }, resetButtonText));
  }), _react.default.Children.map(children, function (child) {
    // @ts-ignore
    var id = child.props.id;
    if (activeChild && id !== activeChild) return null;
    return child;
  }));
};

var _default = ColorPaletteFilterUi;
exports.default = _default;